import { siteConfig } from "./siteConfig";

export const faqs = [
  {
    q: "What is the batch size and why is it limited to 40?",
    a: "At Sri Sai Institute of Agriculture Sciences, every class is capped at exactly 40 students. This batch size allows our faculty to provide personalized guidance, especially for practical laboratories and field-based research in the agricultural sciences.",
  },
  {
    q: "What programs do you offer?",
    a: "We specialize in undergraduate and postgraduate agricultural sciences, including: B.Sc Agriculture, M.Sc Agriculture, M.Sc Biology, M.Sc Chemistry, and M.Sc Zoology.",
  },
  {
    q: "Are the labs and research facilities modern?",
    a: "Yes. Our institute is equipped with modern labs for soil testing, plant pathology, and agri-biotechnology, along with dedicated research plots for practical agricultural learning.",
  },
  {
    q: "Is residential hostel accommodation available?",
    a: "Yes. We have separate residential campuses for Boys and Girls. Both are designed to provide a safe, focused environment for students pursuing advanced science and agriculture studies.",
  },
  {
    q: "Who are the key faculty members?",
    a: "Our core faculty include experienced academics such as Divi Vamsi Krishna, Sudhineedi Ramesh, and Patchala Thomas, all of whom bring extensive experience in agricultural education and research.",
  },
  {
    q: "How do I apply and when do admissions open?",
    a: `Admissions for the 2026–27 academic year are currently open. You can fill out the enquiry form on our website or contact us at ${siteConfig.phonesDisplay} for detailed information.`,
  },
];
